<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="480"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">{{ $t("update_awb") }}</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--begin::Modal header-->
      <!--begin::Modal body-->
      <div class="modal-body d-flex flex-column scroll-y mx-5 mx-xl-15 py-7">
        <!--begin::Body-->
        <div class="row py-4">
          <v-col cols="12" class="my-0 py-0">
            <v-text-field
              v-model="formData.delivery_no"
              :label="$t('booking_number')"
              clearable
              outlined
              dense
              :error-messages="delivery_noErros"
              @input="$v.formData.delivery_no.$touch()"
              @blur="$v.formData.delivery_no.$touch()"
            ></v-text-field>
          </v-col>
        </div>
        <!--end::Body-->

        <!--begin::Actions-->
        <div class="d-flex flex-grow-1 align-end justify-center">
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submit"
          >
            {{ $t("submit") }}
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

export default {
  name: "BulkEditDestination",
  mixins: [validationMixin],
  props: ["items", "updateTableContent"],
  validations() {
    return {
      formData: {
        delivery_no: { required },
      },
    };
  },
  data: () => ({
    dialog: false,
    formData: {
      delivery_no: null,
    },
  }),
  methods: {
    handleFormValidation(fieldName, vueObj, dataName = "formData") {
      const errors = [];
      if (!vueObj.$v[`${dataName}`][fieldName].$dirty) return errors;
      if ("required" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].required &&
          errors.push(this.$t("validation_this_field_is_required"));
      }
      if ("maxValue" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].maxValue &&
          errors.push(this.$t("validation_this_field_must_be_greater_than_0"));
      }
      if ("url" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].url &&
          errors.push(this.$t("validation_this_url_is_invalid"));
      }
      if ("numeric" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].numeric &&
          errors.push(this.$t("validation_this_must_be_a_number"));
      }
      if ("email" in vueObj.$v[`${dataName}`][fieldName]) {
        !vueObj.$v[`${dataName}`][fieldName].email &&
          errors.push(this.$t("validation_this_email_address_is_invalid"));
      }
      return errors;
    },
    toggleModal() {
      this.reset();
      this.dialog = !this.dialog;
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$store.commit(SET_PAGE_LOADING, true);
      const payload = {
        ids: this.items.map((item) => item.id),
        delivery_no: this.formData.delivery_no,
      };
      ApiService.post(`shipping/pickup_orders/assign-awb`, payload)
        .then(({ data }) => {
          Swal.fire({
            title: this.$t("notificationtitle_success"),
            html:
              "<ul style='font-size: 12px;'> <li>" +
              data.messages.join(" </li><li>") +
              "</li></ul>",
            icon: "success",
            showConfirmButton: true,
            // timer: 2500,
          });
          this.toggleModal();
          this.updateTableContent();
        })
        .catch(() => {
          this.$store.commit(SET_PAGE_LOADING, false);
        });
    },

    reset() {
      this.formData = {
        awb: null,
        booking_no: null,
      };
      this.$v.$reset();
    },
  },
  computed: {
    delivery_noErros: function () {
      return this.handleFormValidation("delivery_no", this, "formData");
    },
  },
  mounted() {},
};
</script>
